import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import usePagination from 'modules/core/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import Item from './_Item'

interface Props {
  clockPictures: ClockPicture[]
  employeeFullName: string
}

const Body = ({ clockPictures, employeeFullName }: Props) => {
  const { paginatedItems, loadMore, hasMore, page } = usePagination({
    batchSize: 50,
    items: clockPictures,
  })

  if (clockPictures.length === 0) {
    return (
      <Table.Body>
        <Table.Blank colSpan={1} text={i18n.t('time_tracking.settings.face_recognition.blank')} />
      </Table.Body>
    )
  }

  return (
    <Table.BodyWithInfiniteScroll page={page} loadMore={loadMore} hasMore={hasMore} colSpan={16}>
      {paginatedItems.map((clockPicture) => (
        <Item
          key={clockPicture.id}
          clockPicture={clockPicture}
          employeeFullName={employeeFullName}
        />
      ))}
    </Table.BodyWithInfiniteScroll>
  )
}

export default observer(Body)
